export default __webpack_public_path__ + "static/media/activity_4.0e87cdfe.png";